import React, {useEffect, useState} from 'react'
import './AuthPage.scss'
import {useTranslation} from 'react-i18next';
import {useLocation, useNavigate} from 'react-router-dom';
import InputLabel from "../../components/Input/InputLabel/InputLabel";
import Button from "../../components/Buttons/Button/Button";
import route from "../../utils/routes.json";
import routes from "../../utils/routes.json";
import {RequestAuth} from "../../request/RequestAuth";
import {Auth} from "../../utils/Auth";
import {jwtDecode} from "jwt-decode";
import tradeCenter from "../../assets/img/pexels-nadi-lindsay-5320288.jpg"
import {useNotification} from "../../containers/NotificationContext/NotificationContext";
import NavTo from "../../components/NavTo/NavTo";

function AuthPage({}) {
    const router = useNavigate();
    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const requestAuth = new RequestAuth();
    const [authType, setAuthType] = useState();
    const location = useLocation();
    const [username, setUsername] = useState('');
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const auth = new Auth();
    const [isChecked, setIsChecked] = useState(false)
    const notificationService = useNotification();

    useEffect(() => {
        async function verifierToken() {
            const token = await auth.getJwtToken();
            if (token !== null) {
                const dcode = jwtDecode(token);
                const currentTime = Math.floor(Date.now() / 1000);
                const tokenValide = currentTime < dcode.exp;
                if (tokenValide) {
                    router(routes.home);
                }
            }
        }

        verifierToken();
    }, []);

    useEffect(() => {
        setError("")
    }, [authType]);
    useEffect(() => {
        setAuthType(location.state)
    }, [location.state]);

    async function connected() {
        try {
            const resp = await requestAuth.login(login, password);
            await auth.setJwtToken(resp.data);
            router(routes.home);
        } catch (e) {
            let msgError = ""
            if (e.response.status === 401) {
                msgError = t('errors.invalidLoginForm')
            } else if (e.response.status === 403) {
                msgError = t('verifyEmail.verifyEmailFirst')
            } else {
                msgError = t('errors.errorLogin')
            }
            setError(msgError);
        }
    }

    async function register() {
        try {
            if (password === confirmPassword && (password.length >= 8) && isChecked) {
                await requestAuth.register(username, login, password, i18n.language);
                notificationService.notify(t('verifyEmail.sent'), "success");
                router(routes.home);
            } else {
                password !== confirmPassword ? setError(t('errors.incorrectPwdConfirm')) : !isChecked ? setError(t('errors.legalNoChecked')) : setError(t('errors.pwdSize'))
            }
        } catch (e) {
            let msgError = ""
            if (e.response.status === 409) {
                msgError = t('errors.userAlreadyRegistered')
            } else if (e.response.status === 401) {
                msgError = t('errors.invalidRegistrationForm')
            } else if(e.response.status === 403) {
                notificationService.notify(t('verifyEmail.sent'), "success");
                router(routes.home);
            } else {
                msgError = t('errors.errorRegistering')
            }
            setError(msgError);
        }
    }

    useEffect(() => {
    }, [isChecked])

    return (
        <div className="login-wrapper">
            <div className="login-sidebar">
                <img src={tradeCenter} className="sidebar-image" alt="Trading platform" />
            </div>
            
            <div className="login-main">
                <div className="auth-card premium-card animate-fade-up">
                    <div className="auth-header">
                        <h2>{authType === route.register ? t('login.registration') : t('login.connection')}</h2>
                        <p>{authType === route.register ? t('login.registerWelcome') : t('login.loginWelcome')}</p>
                    </div>

                    <form className="auth-form" onSubmit={(e) => e.preventDefault()}>
                        {authType === route.register && (
                            <div className="input-group">
                                <InputLabel label={t('login.username')} type="text" id="username"
                                    onInputChange={setUsername} />
                            </div>
                        )}
                        
                        <div className="input-group">
                            <InputLabel label={authType === route.register ? t('login.email') : t('login.email-username')}
                                type="text" id="email" onInputChange={setLogin} />
                        </div>
                        
                        <div className="input-group">
                            <InputLabel label={t('login.password')} type="password" id="password"
                                onInputChange={setPassword} onEnterPressed={authType === route.login ? connected : null} />
                        </div>
                        
                        {authType === route.register && (
                            <div className="input-group">
                                <InputLabel label={t('login.confirmPassword')} type="password" id="confirm-password"
                                    onInputChange={setConfirmPassword} onEnterPressed={register} />
                            </div>
                        )}

                        {authType === route.register && (
                            <div className="acceptance-group">
                                <label className="checkbox-container">
                                    <input type="checkbox" checked={isChecked} onChange={() => setIsChecked(!isChecked)} />
                                    <span className="checkmark"></span>
                                    <span className="acceptance-text">
                                        {t('legal.acceptance.part1')} <span className="legal-link" onClick={() => router(routes.legal)}>{t('legal.acceptance.part2')}</span>
                                    </span>
                                </label>
                            </div>
                        )}

                        {authType === route.login && (
                            <NavTo path={routes.forgotPassword} className="forgot-password-link">
                                {t('login.forgotPassword')}
                            </NavTo>
                        )}

                        {error && <div className="auth-error">{error}</div>}

                        <Button 
                            children={authType === route.login ? t('login.connect') : t('login.register')}
                            styles="button auth-submit-btn" 
                            handleClick={authType === route.login ? connected : register} 
                        />
                        
                        <div className="auth-switch">
                            <span>{authType === route.login ? t('login.noAccount') : t('login.alreadyAccount')}</span>
                            <button 
                                type="button"
                                className="switch-btn"
                                onClick={authType === route.register ? () => setAuthType(route.login) : () => setAuthType(route.register)}
                            >
                                {authType !== route.login ? t('login.connect') : t('login.register')}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default AuthPage